$(document).keyup(function (e) {
  if (e.keyCode === 27) {
    decline();
  }
});
$(document).ready(function () {
  $(".disclaimerpop").each(function () {
    if ($(".header")[0]) {
      $(this).find('.header').addClass("firstChild");
      $(this).find('.holder').addClass("secondChild");
    }
    else {
      $(this).find('.holder').addClass("firstChild");
    }
  });
});
function decline() {
  self.parent.closeModal();
  return false;
}
function agree(url, target) {
  if (!target) {
    target = '_self';
  }

  parent.window.location.target = target;
  parent.window.location.href = encodeURI(url);  //TODO make sure http odes not get encoded

  return false;
}
/* the following function will be used when content editors embed links with in the content displayed */
function closedialogpopup() {
  self.parent.closeModal();
  return true;
}

